$(document).ready(function() {

  $(".html5-video-player:not(.ytp-transparent), .html5-video-player.unstarted-mode, .html5-video-player.ad-showing, .html5-video-player.ended-mode").css("background-color", "#fff");
  
//Remove the "review" on 16-08-2023

    setTimeout(function() {
      $(".alrv-prod-rating__text").each(function() {
      var text = $(this).text();
      text = text.replace(" reviews", ""); 
      $(this).text(text);
      });
    }, 3000);

        const video = $('.video_1');
            const unmuteButton = $('.unmute_button');

            if (!video.attr('autoplay')) {
                unmuteButton.addClass('mute-btn-hide');
            }

// Slidercounts
   if ($('.dots_option').length) {
        $(window).on('resize', function() {
            if ($(window).width() <= 749) {
                $('.multicolumn .slider-counter').hide();
            } else {
                $('.multicolumn .slider-counter').show();
            }
        });
        $(window).trigger('resize');
     }
  
  });